import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AsyncAppThunk } from "../application-state";
import { showLoaderWhile } from "./ui";
import { PowerBiReportModel } from "libs/models/power-bi";
import { getReportConfigService } from "services/crosspay-service";
import { ReportType } from "libs/report-enum";
import { getReportId } from "utils/report-util";

export interface PowerBiStore {
  ReportConfig: PowerBiReportModel | undefined;
}

const initialState: PowerBiStore = {
  ReportConfig: undefined,
};

const slice = createSlice({
  name: "power-bi",
  initialState,
  reducers: {
    setReportConfig: (
      state: PowerBiStore,
      action: PayloadAction<PowerBiReportModel | undefined>
    ) => {
      state.ReportConfig = action.payload;
    },
  },
});

export const { setReportConfig } = slice.actions;

export const reducer = slice.reducer;

export const getReportConfig =
  (type: ReportType): AsyncAppThunk =>
  async (dispatch, store) => {
    dispatch(
      showLoaderWhile(async () => {
        const reportId = getReportId(type);
        dispatch(setReportConfig(undefined));
        const apiResponse = await getReportConfigService(reportId);
        if (
          apiResponse &&
          Object.keys(apiResponse).length > 0 &&
          apiResponse.result !== null
        ) {
          dispatch(setReportConfig(apiResponse.result));
        }
      })
    );
  };
